<template>
    <div class="text-center">

        <div class="contenedor-boton">
            <v-btn 
                small
                depressed
                icon
                v-if="page != 1"
                @click="$emit('paginaAnt')"
            >
                <v-icon>fas fa-angle-left</v-icon>
            </v-btn>
        </div>

        <div class="contenedor-boton-selector">
            <v-select
                v-model="valor"
                :items="pageItems"
                item-text="texto"
                item-value="numero"
                @change="paginaActual"
            ></v-select>
        </div>

        <div class="contenedor-boton">
            <v-btn 
                small
                depressed
                icon
                v-if="page < pages"
                @click="$emit('paginaSig')"
            >
                <v-icon>fas fa-angle-right</v-icon>
            </v-btn>
        </div>
        
        <div class="contenedor-boton">
            <v-chip 
                md
                inline
                label
                outlined
                class="font-weight-regular"
            >
                {{page}}/{{pages}}
            </v-chip>
        </div>

        <div class="contenedor-boton">
            <v-chip 
                md
                inline
                label
                outlined
                class="font-weight-regular"
            >
                {{cantPage}} - {{perPage}} de {{totalDatos}}
            </v-chip>
        </div>
    </div>
</template>

<script>

export default {
    name: 'paginacion',
    props: ['page','pages','totalDatos','perPage','cantPage'],
    data: () => ({
        valor: 1,
    }),
    watch: {
        page(){
            this.valor = this.page;
        }
    },
    computed: {
        pageItems () {
            let paginas = [];
            for (let i = 1; i <= this.pages; i++) {
                const pagina = {
                    numero: i,
                    texto: `Página ${i}`,
                }
                paginas.push(pagina);
            }
            return paginas;
        }
    },
    methods: {
        paginaActual() {
            this.$emit('cambiarPag', this.valor);
        }
    }
}

</script>

<style>
    .contenedor-boton {
        display: inline-block;
        padding: 7px;
        text-align: center;
    }
    .contenedor-boton-selector {
        display: inline-block;
        text-align: center;
        padding: 7px;
        width: 10%;
    }
</style>


































